import styled from 'styled-components';

export default styled.hr`
    border: 0;
    height: 1px;
    background-image: linear-gradient(to right, rgba(69, 90, 100, 0.05), rgba(69, 90, 100, 0.5), rgba(69, 90, 100, 0.05));
    margin: ${props => props.margin ? props.margin : '2em 0 1em'};
    clear: both;
    overflow: hidden;
`;



// WEBPACK FOOTER //
// ./src/components/styles/HorizontalDivider.js